













import { Component, Vue, Prop } from 'vue-property-decorator'
import Lobby from '@/components/Lobby/Lobby.vue'
import Game from '@/components/Game/Game.vue'
import SideMenu from '@/components/SideMenu/SideMenu.vue'
import { Room } from '@/class/room'

@Component({
  components: {
    Lobby,
    Game,
    SideMenu
  }
})

export default class PlayerView extends Vue {
  @Prop() roomId!: string;
  @Prop() playerId!: string;
  room: Room = new Room(this.roomId, this.playerId);

  get isLoading () {
    if (this.room.isLoading) {
      return true
    }

    if (this.room.game?.isLoading) {
      return true
    }

    return false
  }
}
